import { Ghost } from "@ui/Ghost";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { HStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { Show } from "solid-js";
import { formatTimeWorked } from "./formatters";

type Props = {
	chatThinking: boolean;
	timeWorkedSeconds: number | null | undefined;
};

export const ChatTimeWorkedStat = (props: Props) => (
	<div class="cost-dropdown__stat">
		<Text
			as="span"
			family="mono"
			size="xsmall"
			weight="bold"
			color="fg3"
			transform="uppercase"
			style={{
				display: "block",
				"margin-bottom": "0.375rem",
			}}
		>
			Time worked
		</Text>

		<HStack spacing="medium" align="center">
			<MaterialSymbol
				symbol="timer"
				color="fg2"
				relativeSize="even-larger"
			/>
			<Show
				when={!props.chatThinking}
				fallback={<Ghost width="2.5rem" height="1.5rem" />}
			>
				<Text size="xlarge" weight="extra-bold" color="ink" family="display">
					{formatTimeWorked(props.timeWorkedSeconds)}
				</Text>
			</Show>
		</HStack>

		<Text
			as="span"
			size="xsmall"
			color="fg3"
			style={{ display: "block", "margin-top": "0.375rem" }}
		>
			processing time across the thread
		</Text>
	</div>
);
